import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import {environment} from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class ParameterService {

	constructor(private http: HttpClient) { }

	getRoleUser() {
		return this.http.get<any>(environment.financialUrl + '/parameter/' + sessionStorage.getItem('country') + '/' + sessionStorage.getItem('username'));
	}

	getApsRole() {
		return this.http.get<any>(environment.financialUrl + '/aps/' + sessionStorage.getItem('username'));
	}

}
